var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconActionLock24Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.124,
    height: 28.124,
    viewBox: "0 0 28.124 28.124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.093 9.96H19.92V7.617a5.861 5.861 0 0 0-5.86-5.86 5.861 5.861 0 0 0-5.858 5.86V9.96H7.03a2.35 2.35 0 0 0-2.344 2.344v11.718a2.35 2.35 0 0 0 2.344 2.344h14.062a2.35 2.35 0 0 0 2.343-2.344V12.304a2.35 2.35 0 0 0-2.343-2.344zm-7.031 10.547a2.35 2.35 0 0 1-2.344-2.344 2.35 2.35 0 0 1 2.344-2.343 2.35 2.35 0 0 1 2.343 2.343 2.35 2.35 0 0 1-2.343 2.344zM10.546 9.96V7.617A3.51 3.51 0 0 1 14.062 4.1a3.51 3.51 0 0 1 3.515 3.516V9.96h-7.03z",
    id: "6l8tnj0yza"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uyxyj3h7qb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6l8tnj0yza"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#uyxyj3h7qb)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28.124v28.124H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionLock24Px);
export default __webpack_public_path__ + "static/media/icon-action-lock-24-px.1adaa9108e7a8b11a20ad24d5bec7287.svg";
export { ForwardRef as ReactComponent };